import { Button, Card, Center, FileButton, Loader } from '@mantine/core';
import { IconPhoto } from '@tabler/icons-react';
import { useTranslation } from 'react-i18next';

import UserAvatar from 'src/Components/NavBar/UserAvatar/UserAvatar.component';
import useUpdateProfilePicture from 'src/Hooks/Mutations/useUpdateProfilePicture';
import useFetchUser from 'src/Hooks/Queries/useFetchUser';

import styles from './ProfileDetails.module.scss';

const ProfileDetails = () => {
  const { t } = useTranslation();
  const { data: user, isLoading: isUserLoading } = useFetchUser();
  const { mutate: updateProfilePicture, isLoading: isUpdating } = useUpdateProfilePicture();

  if (isUserLoading) {
    return (
      <Card withBorder radius="md" p="xl" style={{ minHeight: 200 }}>
        <Center style={{ height: '100%' }}>
          <Loader />
        </Center>
      </Card>
    );
  }

  const handleFileSelected = (file: File) => {
    updateProfilePicture(file);
  };

  return (
    <Card withBorder radius="md" p="xl">
      <fieldset style={{ border: 'none', padding: 0 }}>
        <div className={styles.container}>
          <div>
            <div className={styles.title}>{t('profileDetails.common.title', 'Profil public')}</div>
            <div className={styles.subtitle}>
              {t(
                'profileDetails.common.subtitle',
                'Ces informations seront affichées publiquement sur votre profil.'
              )}
            </div>
          </div>

          <div className={styles.userSection}>
            <UserAvatar size={'xl'} user={user} />
            <FileButton
              onChange={file => file && handleFileSelected(file)}
              accept="image/png,image/jpeg"
            >
              {props => (
                <Button {...props} loading={isUpdating} leftSection={<IconPhoto size={16} />}>
                  {t('profileDetails.common.changePhoto', 'Changer la photo')}
                </Button>
              )}
            </FileButton>
          </div>

          <div className={styles.userInfo}>
            <div className={styles.name}>
              {user?.firstName} {user?.lastName}
            </div>
            <div className={styles.email}>{user?.email}</div>
          </div>
        </div>
      </fieldset>
    </Card>
  );
};

export default ProfileDetails;
